import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Fa from 'react-fontawesome';
import { Field } from 'redux-form';
import DatePicker from 'react-datepicker';
import {
  FormGroup, HelpBlock,
} from 'react-bootstrap';
import masterField from '../../../../../components/search-form/master-field';
import styles from '../styles.css';

const DateInput = ({ value, onClick }) => {
  const hasValue = value !== null && value !== undefined && value.length > 0;
  const icon = !hasValue ? (<span><Fa name="calendar-o" />{' '}</span>) : null;
  return (
    <a href="" onClick={(e) => { e.preventDefault(); onClick(); }}>
      {icon}{hasValue ? value : 'Select a date'}
    </a>
  );
};
DateInput.propTypes = {
  value: PropTypes.string,
  onClick: PropTypes.func,
};
DateInput.defaultProps = {
  value: null,
  onClick: () => {},
};

class DateField extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    this.renderDatePicker = this.renderDatePicker.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
  }

  handleDateChange(date) {
    this.props.onChange(date ? date.startOf('day') : null);
  }

  renderDatePicker({
    date, meta: { touched, error }, placeholder,
  }) {
    const { disabled } = this.props;
    const validationState = touched && error ? 'error' : null;
    return (
      <FormGroup validationState={validationState} className={styles.datePicker}>
        <DatePicker
          dateFormat="DD MMM YYYY"
          className="form-control clickable"
          selected={date}
          showYearDropdown
          disabled={disabled}
          isClearable={false}
          scrollableYearDropdown
          placeholderText={placeholder}
          onChange={this.handleDateChange}
          customInput={<DateInput />}
        />
        {touched && error && <HelpBlock>{error}</HelpBlock>}
      </FormGroup>
    );
  }

  render() {
    const { disabled, value, isAccount } = this.props;

    const field = (
      <Field
        name="start_date"
        date={value}
        disabled={disabled}
        component={this.renderDatePicker}
        label="Start Date"
        placeholder="Select start date"
      />
    );
    
    const acc = isAccount ? ` account's ` : '';

    if (isAccount) {
     
      if (!value) {
        return (
          <div>
            <div>{field}</div>
            <HelpBlock>Include all accounts with won opportunity close dates on, or after, the selected start date for possible reminder emails.</HelpBlock>
          </div>
        );
      }
  
      return (
        <div>
          Include all accounts with won opportunity close dates on, or after {field}.
        </div>
      );
    }

    if (!value) {
      return (
        <div>
          <div>{field}</div>
          <HelpBlock>Include all {acc} opportunities with close dates on, or after, the selected start date for possible reminder emails.</HelpBlock>
        </div>
      );
    }

    return (
      <div>
        Include all {acc} opportunities with close dates on, or after {field} for possible reminder emails.
      </div>
    );
  }
}

DateField.propTypes = {
  value: PropTypes.instanceOf(moment),
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  isAccount: PropTypes.bool,
};
DateField.defaultProps = {
  value: null,
  disabled: false,
  onChange: () => {},
  isAccount: false,
};
export default masterField(DateField);
